<template>
    <div>
        <el-radio-group v-show="!init_error" v-model="context" @change="handle_selection_change">
            <el-radio 
                v-for="(option, idx) in options" 
                :label="option.value"
                :key="idx"
            >
                {{option.label}}
            </el-radio>
            <el-radio label="其它">其它
            </el-radio>
        </el-radio-group>
        <el-input 
            v-model="others" 
            @input="context='其它'"
            @change="handle_selection_change(others)"
            :disabled="context !== '其它'"
        >
        </el-input>
    </div>
</template>

<script>


export default {
    props: ['value', 'options'],
    data() {
        return {
            init_error: false,
            form_valid: true,
            others: null,
            context: null,
        }
    },
    watch: {
        value () {
            this.init()
        },
        options () {
            this.init()
        }
    },
    created: function () {
        this.init()
    },
    methods: {
        init () {
            console.log('SelectWithOptionOthers: init: value=', this.value)
            if (!this.options) {
                console.warn('SelectWithOptionOthers: invalid options')
                this.init_error = true
                return
            }

            if (this.options.map(x=>x.value).indexOf('其它') !== -1) {
                console.warn('SelectWithOptionOthers: cannot use 其它 as value')
                this.notify_message(this.ERROR.LEVEL.ERROR, '不能使用 "其它" 作為值')
                this.init_error = true
                return
            }

            this.context = null
            this.others = null

            if (this.options.map(x=>x.value).indexOf(this.value) === -1) {
                this.context = '其它'
                this.others = this.value
            }
            else {
                this.context = this.value
            }
        },
        handle_selection_change (val) {
            console.log('select: ',val)
            if (val === '其它') {
                this.$emit('change', this.others)
            }
            else {
                this.$emit('change', val)
            }
        }
    }
};
</script>


<style lang="scss" scoped>
/deep/.el-form-item__label {
background-color: rgba(25, 111, 61, 0.1);
padding: 0 5px;
}
/deep/.el-form-item__content {
   padding: 0 5px;
}
/deep/.el-tag + .el-tag {
margin-left: 10px;
}

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  padding: 5px;
  background-color: rgba(25, 111, 61, 0.1);
  width: 200px;
  vertical-align: top;
  &+.value {
    vertical-align: top;
    padding: 5px;
  }
}

</style>
